module.exports = __webpack_public_path__ + "static/media/warranty.d0bf14d4.png";